<template>
  <div class="factory">
    <div class="title1">{{$t('meg.factory')}}</div>
    <p style="font-size: .175rem;color: #818AA0;line-height: .1875rem;">Platform Factory</p>
    <div class="factoryBox">
        <li class="aaa"   v-for="(item,index) in plantData" :key="index" @click="facdetail(item.plantId)" :style="{ backgroundImage: 'url(' + item.pictures[0].url + ')' }" style="background-repeat: no-repeat;background-size: 100% 100%;">
            <div class="footBox">
                <h1 class="factoryTitle">{{ item.plantAlias }}</h1>
                <div class="address">
                    <!-- <span style="margin-right: 19px;">{{ item.plantAddress }}</span>
                    <span>三层D1242号</span> -->
                </div>
                <div style="display: flex;justify-content: end;">
                    <!-- <span class="phone">(010)6592-2732</span> -->
                    <span class="lookDetails">{{$t('meg.viewDetail')}}</span>
                </div>
            </div>
        </li>
    </div>
    <div class="moreProduct" @click="more">{{$t('meg.viewFactory')}}</div>
  </div>
</template>

<script setup>
import { selectPlantList } from "@/api/home.js"
import { onMounted, ref } from "vue";
import { useRouter } from 'vue-router';
const router = useRouter()

const plantData = ref([])
onMounted(()=> {
    getPlantList()
})
const getPlantList = () => {
    selectPlantList().then(res => {
        if(res.data.code == 200) {
            plantData.value = res.data.rows.splice(0,6)
        }
    })
}

const more = () => {
    router.push("/factory")
}

const facdetail = (plantId) => {
    router.push({ path: '/factortDetail', query: { plantId: plantId } })
}
</script>

<style>
.title1 {
    font-size: .3rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    margin-top: .625rem;
}
.aaa {
    cursor: pointer;
}
.factoryBox {
    margin: .5rem 1.625rem;
    display: flex;
    gap: .25rem;
    flex-wrap: wrap;
}
.factoryBox li {
    width: 32%;
    height: 3.6625rem;
    /* background: #F2F2F2; */
    /* background: url("../../../assets/newImg/factory.png") no-repeat; */
    border-radius: 0rem 0rem 0rem 0rem;
    opacity: 1;
    display: flex;
    flex-direction: column-reverse;
}
.footBox {
    height: 1.725rem;
    background: #FFFFFF;
    border-radius: 0rem 0rem 0rem 0rem;
    opacity: 0.72;
    padding-bottom: .225rem;
}
.factoryTitle {
    font-size: .275rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #000000;
    text-align: left;
    margin-left: .425rem;
    margin-top: .275rem;
}
.address {
    text-align: left;
    margin-left: .425rem;
    margin-top: .2625rem
}
.address span {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 600;
    color: #000000;
}
.phone {
    font-size: .225rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 700;
    color: #000000;
    margin-left: .425rem;
}
.lookDetails {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #000000;
    margin-right: .6625rem;
}


.moreProduct {
    width: 7.9rem;
    height: .825rem;
    background: #FFFFFF;
    border-radius: 0rem 0rem 0rem 0rem;
    opacity: 1;
    border: .0125rem solid #000000;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #000000;
    margin: .425rem auto;
    line-height: .825rem;
    cursor: pointer;
}
</style>
